import { css } from "lit";

export const previewPublishModalStyles = css`
  .preview-container {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-400);
    overflow: auto;
  }

  .preview-title {
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-body-size-large);
    font-weight: var(--sds-typography-weight-medium);
    line-height: 1.2;
    margin: 0;
    color: var(--sds-color-text-default-default);
  }

  .preview-content {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
  }

  /* Thumbnail Preview */
  .thumbnail-preview {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: var(--sds-size-radius-400);
    overflow: hidden;
    background-color: var(--sds-color-background-default-secondary);
    aspect-ratio: 0.7;
    max-width: 300px;
    margin: 0 auto;
  }

  .thumbnail-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .no-thumbnail {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--sds-size-space-200);
    background-color: var(--sds-color-background-default-secondary);
    border: 1px dashed var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-400);
    padding: var(--sds-size-space-600);
    color: var(--sds-color-text-default-secondary);
    aspect-ratio: 0.7;
    max-width: 300px;
    margin: 0 auto;
  }

  .no-thumbnail ph-image {
    color: var(--sds-color-text-default-tertiary);
  }

  .no-thumbnail span {
    font-size: var(--sds-typography-body-size-small);
    text-align: center;
  }

  /* Content Preview */
  .content-preview {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-300);
  }

  .preview-section-title {
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-body-size-medium);
    font-weight: var(--sds-typography-weight-medium);
    line-height: 1.2;
    margin: 0;
    color: var(--sds-color-text-default-default);
  }

  .description-text {
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-small);
    font-weight: var(--sds-typography-weight-regular);
    line-height: 1.5;
    margin: 0;
    color: var(--sds-color-text-default-default);
    background-color: var(--sds-color-background-default-secondary);
    padding: var(--sds-size-space-400);
    border-radius: var(--sds-size-radius-200);
    border: 1px solid var(--sds-color-border-default-default);
  }

  /* Expandible Switches */
  .form-field {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-200);
  }

  .form-field input[type="datetime-local"] {
    padding: var(--sds-size-space-300);
    border: 1px solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-200);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-small);
    background-color: var(--sds-color-background-default-default);
    color: var(--sds-color-text-default-default);
  }

  .form-field input[type="datetime-local"]:focus {
    outline: none;
    border-color: var(--sds-color-border-brand-default);
    box-shadow: 0 0 0 2px var(--sds-color-background-brand-secondary);
  }

  /* Switch section styling */
  .switch-section {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-300);
  }

  .cover-status-alert {
    margin-left: var(--sds-size-space-400);
  }

  /* Alert styling */
  .alert-container {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-200);
  }

  .alert {
    padding: var(--sds-size-space-300);
    border-radius: var(--sds-size-radius-200);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-small);
    font-weight: var(--sds-typography-weight-medium);
  }

  .alert.success {
    background-color: var(--sds-color-background-success-secondary);
    color: var(--sds-color-text-success-default);
    border: 1px solid var(--sds-color-border-success-default);
  }

  /* Mobile responsiveness */
  @media (max-width: 768px) {
    .preview-container {
      gap: var(--sds-size-space-300);
    }

    .preview-content {
      gap: var(--sds-size-space-400);
    }

    .thumbnail-preview,
    .no-thumbnail {
      max-width: 250px;
    }
  }
`;
